// extracted by mini-css-extract-plugin
export default {"cls1":"TbMVgrHbmO3tn2xDPCP_","cls2":"hc2IOmO3hUZSQ_yDyLim TbMVgrHbmO3tn2xDPCP_"};